import { Box, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

export default function ToolBar(props) {
  return (
    <Box
      sx={{
        display: "flex",
        marginTop: "10px",
      }}
    >
      <span
        style={{
          marginLeft: "20px",
        }}
      />
      {props.accountInfo && (
        <>
          <Typography variant="caption" sx={{ marginRight: "30px" }}>
            <b>ORG:</b> {props.accountInfo.org}
          </Typography>

          <Typography variant="caption" sx={{ marginRight: "30px" }}>
            <b>BANKID:</b> {props.accountInfo.bankId}
          </Typography>

          <Typography variant="caption" sx={{ marginRight: "30px" }}>
            <b>FID:</b> {props.accountInfo.fid}
          </Typography>

          <Typography variant="caption" sx={{ marginRight: "30px" }}>
            <b>ACCTID:</b> {props.accountInfo.acctId}
          </Typography>

          <Typography variant="caption" sx={{ marginRight: "30px" }}>
            <b>BRANCHID:</b> {props.accountInfo.branchId}
          </Typography>
        </>
      )}
    </Box>
  );
}
